<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
       <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container mt-5">
          <div class="row">
            <div class="col-sm-12">
              <div class="heading mt-3">
                <vs-breadcrumb
                  align="left"
                  :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/program-officer/todoList',
                    },
                    {
                      title: 'Trainings',
                      url: '#',
                      active: true
                    }
                  ]"
                ></vs-breadcrumb>
                <!-- <h3 class="text-secondary">Training Name</h3> -->
              </div>
            </div>
          </div>
          
          <div class="row" style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);">
             <!-- training title name section starts -->
          <div class="form-group form-row text-dark">
            <h6 class="sub-frm-title">Event Information</h6>
            <div class="row col-sm-12">
              <label class="col-sm-1 font-weight-bold" style="color:#6c757d;">
                <h5>Title:</h5>
              </label>
              <div class="col-sm-11" style="color:#6c757d;">
                <h5>{{trainingArr.title}}</h5>
              </div>
            </div>
            <div class="row col-sm-12">
              <label class="col-sm-2 font-weight-bold" style="padding:0px 0px 0px 15px">
                <h6>Start Date: </h6>
              </label>
              <h6
                class="col-sm-2"
                style="padding:0px 0px 0px 15px;color:#6c757d;"
              >{{trainingArr.startdate}}</h6>

              <label class="col-sm-2 font-weight-bold p-0">
                <h6>End Date:</h6>
              </label>
              <h6
                class="col-sm-4 p-0"
                style="color:#6c757d;"
              >{{trainingArr.enddate}}</h6>
            </div>
          </div>
          <!-- training title name section ends -->
          <div class="table-responsive">
            <table class="table table-striped col-sm-8">
               <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>View Report</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(trainee, index) in trainees" v-bind:key="trainee.id">
          <td>{{index+1}}</td>
          <td>{{trainee.name}}</td>
           <td>
              <i class="material-icons">
                <router-link :to="{ path: '/dashboard/programOfficer/traineePreassessmentReport', query: { traineeId: trainee.id,trainingId:training_id }}">visibility</router-link>
              </i>
            </td>
        </tr>
      </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
// flatPickr
import "flatpickr/dist/flatpickr.css";
// Import this component
// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  data: () => ({
    basepath: process.env.VUE_APP_BASE_PATH,
    colorx: "warning",
    ApprovedTrainingME: [],
    training_id:"",
    isSidebar: false,
    trainingArr: [],
    trainees : [],
    datesArr: [],
    settings: {
      maxItems: null,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    fundingAgencyArr: "",
    thematicAreaArr: "",
    projectArr: "",
    subProgramArr: "",
    programOfficerArr: "",
    advisorArr: "",
    filterArr: [],
    filter: {
      fundingAgency: "",
      startDate: "",
      endDate: "",
      codeNo: "",
      thematicArea: "",
      trainingType: "",
      project: "",
      subProgram: "",
      programOfficer: "",
      advisor: "",
      trainers: ""
    },
    dateOptions: {
      wrap: true,
      weekNumbers: true,
      dateFormat: "d-m-Y"
    }
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.trainingId = this.$route.query.trainingId;

    // Set the initial number of items
    // this.totalRows = this.items.length;
    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/thematic/get/all/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.thematicAreaArr = response.data;
      });
    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/report/training/get/"+this.trainingId
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if(response.data.training){
          this.trainingArr = response.data.training
          this.training_id = response.data.training.id
        }
        if(response.data.trainees){
          this.trainees = response.data.listTrainee
        }
       
      });
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    makeActive() {
      alert("Worked");
    },
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
#page-content-wrapper {
  width: 100%;
  position: relative;
}
.active {
  background: #dff0d8 !important;
  /* color:#fff !important; */
}
.active.training-title-cards {
  color: #fff !important;
}
ul.date-ul {
  display: inline-flex;
}
.date-ul li.start-date {
  padding-right: 35px;
}
.cards-row {
  margin-top: 10px !important;
}
.card-col {
  padding: 5px !important;
}
.main-card {
  color: #6c757d;
  border: 1px dotted #07a7e14f;
}
.main-card:hover {
  border: 1px solid #07a7e14f;
}
.training-title {
  /* font-size: 15px; */
  font-weight: 500;
  /* color: #212529 !important; */
}
.training-title-cards {
  font-size: 15px;
  font-weight: 500;
  /* color: #212529; */
}
.con-vs-card.withHover:hover img {
  -webkit-transform: scale(1);
  transform: scale(1);
}
.cardheader {
  display: inline-flex;
}

@media (max-width: 768px) {
  /* ul.date-ul {
    margin-top: -30px !important;
    display: block;
    margin-bottom: 25px;
  }
  .date-ul li {
    padding: 2px;
  }
  .cardheader {
    display: block;
  } */
  .card-col {
    width: 100% !important;
  }
  ul.date-ul {
    margin-top: 5px;
  }
  .date-ul li.start-date {
    padding-right: 26px;
  }
  .training-title {
    font-size: 14px;
  }
}
@media (max-width: 991.98px) {
  /* ul.date-ul {
    margin-top: -16px;
    display: block;
  } */
  .date-ul li.start-date {
    padding-right: 26px;
  }
  .card-col {
    width: 100% !important;
  }
  ul.date-ul {
    margin-top: 5px;
  }
}



@media only screen and (max-width: 575px) {
  .latest-update-card .card-block .latest-update-box:after {
    display: none;
  }
  .latest-update-card .card-block .latest-update-box .update-meta {
    z-index: 2;
    min-width: 100%;
    text-align: left !important;
    margin-bottom: 15px;
    border-top: 1px solid #f1f1f1;
    padding-top: 15px;
  }
}
@media print {
  #sidebar-wrapper {
    display: none;
  }
}

.con-vs-checkbox {
  justify-content: start;
}

/*!
 * Start Bootstrap - Simple Sidebar (https://startbootstrap.com/template-overviews/simple-sidebar)
 * Copyright 2013-2019 Start Bootstrap
 * Licensed under MIT (https://github.com/BlackrockDigital/startbootstrap-simple-sidebar/blob/master/LICENSE)
 */

body {
  overflow-x: hidden;
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}
#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
/* scrollbar css starts */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(7, 167, 225);
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(7, 167, 225);
}
/* scrollbar css ends */
</style>

